import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { ClientKeys } from "web_myplann/Api/Client/ClientKeys";
import { device } from "web_myplann/Utils/device";

export const useProfilePhotoUpload = () => {
	const queryClient = useQueryClient();
	const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);

	const changeProfilePhoto = async () => {
		setIsUploadingPhoto(true);
		try {
			const response = await device.changeProfileImage();
			if (response.payload.changed) {
				await queryClient.refetchQueries({ queryKey: ClientKeys.all });
			}
		} finally {
			setIsUploadingPhoto(false);
		}
	};

	return { changeProfilePhoto, isUploadingPhoto };
};
